<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-4.h6.basic800--text {{ $t('labels') }}
      v-divider.basic300
      v-card-text.px-4
        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        template(v-else v-for="(customLabel, index) in customLabels")
          div.d-flex.align-center.mt-4
            v-btn.mr-2(small icon :color="selectedLeadLabel && selectedLeadLabel === customLabel.id ? 'info500' : 'basic600'" @click="selectedLeadLabel === customLabel.id ? selectedLeadLabel = null : selectedLeadLabel = customLabel.id")
              v-icon {{ selectedLeadLabel && selectedLeadLabel === customLabel.id ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
            v-icon.mr-2(:color="customLabel.properties.color") mdi-label
            div.s2.primary--text {{ customLabel.properties.text }}
            v-spacer
            v-menu(left)
              template(v-slot:activator="{ on, attrs }")
                v-btn(color="transparent" small icon v-bind="attrs" v-on="on")
                  eva-icon(name="more-vertical-outline" :fill="$vuetify.theme.themes[$theme].primary" width="18" style="margin-bottom: -2px")
              v-list(dense)
                v-list-item(@click="clickEdit(customLabel)")
                  v-list-item-title.s2.basic800--text {{ $t('edit') }}
                v-list-item(@click="clickDelete(customLabel)")
                  v-list-item-title.s2.basic800--text {{ $t('delete') }}
        v-btn.button-Aa-small.px-0.mt-4(color="transparent" text @click="openAddLabel = true" small)
          eva-icon.mr-1(name="plus-outline" :fill="$vuetify.theme.themes[$theme].info500" width="16" style="margin-bottom: -2px")
          div.info500--text {{ $t('create_new') }}
      v-card-actions.px-4.pb-4.pt-0
        v-spacer
        v-btn(color="white" text height=32 @click="showModal = false")
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn(color='info500' depressed height=32 :loading="isLoading" @click="clickUpdate" dark)
          .button-AA-small.basic100--text {{ $t('done') }}

      .modal
        add-label(v-if="openAddLabel" :open.sync="openAddLabel" :selectedLabel="selectedLabel" @add="handleAddItem($event)" @edit="handleEditItem($event)" @close="selectedLabel = null")
        y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('delete_label') }}
            v-card-text.p2.primary500--text.px-4
              div {{ $t('delete_label_description') }}
            v-card-actions
              v-spacer
              v-btn(color='white' text @click="openDeleteDialog = false; selectedLabel = null")
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color='danger500' depressed height=32 @click="startDelete" :loading="isLoading" dark)
                .button-AA-small.basic100--text {{ $t('delete') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddLabel from '@/components/dialogs/database/AddLabel.vue'

export default {
  name: 'CustomLabel',
  components: { AddLabel },
  props: ['open', 'parentLead'],
  data: () => ({
    isFetching: false,
    isLoading: false,
    selectedLabel: null,
    selectedLeadLabel: null,
    openAddLabel: false,
    openDeleteDialog: false,
    customLabels: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fetchCustomLabels()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCustomLabels () {
      this.isFetching = true
      this.$axios.get(`/lead_customlabels?page_size=-1&company=${this.company.id}`)
        .then(resp => {
          if (resp.data && resp.data.results && resp.data.results.length > 0) {
            this.customLabels = resp.data.results
            if (this.lead.custom_label && resp.data.results.filter(f => f.id === this.lead.custom_label.id).length > 0) {
              this.selectedLeadLabel = this.lead.custom_label.id
            }
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    clickEdit (val) {
      this.selectedLabel = val
      this.openAddLabel = true
    },
    clickDelete (val) {
      this.selectedLabel = val
      this.openDeleteDialog = true
    },
    startDelete () {
      this.isLoading = true
      this.$axios.delete(`/lead_customlabels/${this.selectedLabel.id}`)
        .then(() => {
          if (this.selectedLabel.id === this.selectedLeadLabel) {
            this.selectedLeadLabel = null
          }
          this.customLabels = this.customLabels.filter(f => f.id !== this.selectedLabel.id)
          this.selectedLabel = null
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickUpdate () {
      this.isLoading = true
      this.axios.patch(`/leads/${this.lead.pid}/`, { custom_label: this.selectedLeadLabel })
        .then(resp => {
          this.$set(this.lead, 'custom_label', resp.data.custom_label)
          this.selectedLeadLabel = null
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleAddItem (item) {
      this.customLabels.push(item)
    },
    handleEditItem (item) {
      this.customLabels[this.customLabels.findIndex(f => f.id === this.selectedLabel.id)] = item
      this.selectedLabel = null
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "labels": "Labels",
    "edit": "Edit",
    "delete": "Delete",
    "create_new": "Create new",
    "cancel": "Cancel",
    "done": "Done",
    "delete_label": "Delete label",
    "delete_label_description": "Are you sure you want to delete this label? This label will be deleted permanently."
  },
  "id": {
    "labels": "Label",
    "edit": "Edit",
    "delete": "Hapus",
    "create_new": "Buat baru",
    "cancel": "Batal",
    "done": "Selesai",
    "delete_label": "Hapus label",
    "delete_label_description": "Yakin ingin menghapus label ini? Label ini akan dihapus secara permanen."
  }
}
</i18n>
